import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import ShipmentName from "../../components/shipment/ShipmentDetail/ShipmentName.tsx";
import {useLocationFormState} from "../../components/shipment/ShipmentForm/ShipmentUpdateForm";
import ShipmentUpdateFormProvider from "../../components/shipment/ShipmentForm/ShipmentUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ShipmentUpdateEditPage = () => {
    
    useTitle(t`Update Shipment`);

    const { shipmentId: id } = useParams();
    
    return (
        <Box data-testid="Shipment-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="Shipment-update-title"
                    >
                        <Trans>Edit Shipment</Trans>:  <ShipmentName id={id}/>
                    </Typography>
                    <ShipmentUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default ShipmentUpdateEditPage;
